module.exports = __webpack_public_path__ + "img/logro4.1b332b65.webp";